<template>
  <Form :model="userItem" ref="formValidate" :label-width="100" :rules="userValidate">
    <FormItem label="用户名：" prop="userName" v-if="!userItem.id">
      <Input v-model="userItem.userName" autocomplete="off" placeholder="输入用户名..." v-if="!userItem.id"></Input>
      <span v-if="userItem.id">{{userItem.userName}}</span>
    </FormItem>
      <FormItem label="用户名：" prop="userName" v-else>
      <span >{{userItem.userName}}</span>
    </FormItem>
    <FormItem label="姓名：" prop="name">
      <Input v-model="userItem.name" autocomplete="off" placeholder="输入姓名..."></Input>
    </FormItem>
    <FormItem label="密码：" prop="password" v-if="!userItem.id">
      <Input type="password" autocomplete="off" v-model="userItem.password" placeholder="输入密码..."></Input>
    </FormItem>
    <FormItem label="确认密码：" prop="passwordConfirm" v-if="!userItem.id">
      <Input
        type="password"
        autocomplete="off"
        v-model="userItem.passwordConfirm"
        placeholder="确认密码..."
      ></Input>
    </FormItem>
      <FormItem label="手机：">
      <Input v-model="userItem.phone" placeholder="输入手机号..."></Input>
    </FormItem>
    <FormItem label="角色：" prop="role">
      <Select v-model="userItem.role"  style="width:260px" >
        <Option v-for="item in roleList" :value="item" :key="item">{{ item }}</Option>
      </Select>
    </FormItem>
    <FormItem>
      <Button type="primary" @click="save">保存</Button>
    </FormItem>
  </Form>
</template>
<script>
import { saveUser,updateUser } from "@/api/user";
export default {
  props:['userItem'],
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.userItem.password) {
        callback(new Error("两次密码输入不一致"));
      } else {
        callback();
      }
    };
    const validateUser = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入用户名"));
      } else {
        this.$http.get("/api/User/Exits?username=" + value)
          .then(function(response) {
            if (response.data) {
              if (response.data.success) {
                if (response.data.data) {
                  console.log("用户名已存在");
                  callback(new Error("用户名已存在"));
                } else {
                  callback();
                }
              } else {
              }
            }
          });
      }
    };
    return {
      roleList: ["项目经理","普通用户"],
      userValidate: {
        userName: [
          { type: "string", required: true, message: "用户名不能为空" }
        ],
         name: [
          { type: "string", required: true, message: "姓名不能为空" }
        ],
        password: [{ type: "string", required: true, message: "密码不能为空" }],
        passwordConfirm: [
          { type: "string", required: true, message: "请确认密码" },
          { validator: validatePassCheck, required: true, trigger: "blur" }
        ],
        role:[{ type: "string",required: true,message: "请选择角色",trigger:"change" }]
      }
    };
  },
  watch: {
   
  },
  methods: {
    save() {
      let _this = this;
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          if(_this.userItem.id){
              updateUser(_this.userItem)
              .then(res => {
                _this.$Message.success({
                  content: res.data.message
                });
                _this.$emit('on-Saved');
              })
              .catch(err => {
                _this.$Message.error
                ({
                  content: err.response.data.message
                });
            });
          }else{
            delete _this.userItem.id;
             saveUser(_this.userItem)
            .then(res => {
              _this.$Message.success({
                content: res.data.message
              });
              _this.$emit('on-Saved');
            })
            .catch(err => {
              _this.$Message.error
              ({
                content: err.response.data.message
              });
            });
          }
         
        }
      });
    },
  
  },
  mounted() {
    let _this = this;
  }
};
</script>
